exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map {\n  position: absolute;\n  top: 40px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 0;\n}\n\n#map-nav {\n  background-color: white;\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 500px;\n  text-align: center;\n  background-color: rgba(255,255,255, 0.8);\n}\n\n@media only screen and (max-width: 540px) {\n  #map-nav {\n    width: calc(100% - 40px);\n  }\n}\n\nh2 {\n  margin: 0;\n}\n\ninput {\n  padding: 5px;\n  display: inline-block;\n  margin: 8px 0;\n}\n\nlabel {\n  margin-right: 10px;\n}\n\np.hint {\n  color: #444;\n  font-size: 13px;\n}\n\n.legende-header {\n  border: 0px;\n  display: inline-block;\n  padding: 5px 10px;\n  background-color: rgba(255,255,255, 0.8);\n  margin-top: 10px;\n  font-size: 25px;\n  position: relative;\n  z-index: 1;\n  cursor: default;\n}\n\n.legende-item {\n  border: 10px solid;\n  border-left: none;\n  display: inline-block;\n  padding: 5px 10px;\n  background-color: rgba(255,255,255, 0.8);\n  margin-top: 10px;\n  font-size: 25px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n}\n\n#legende {\n  position: relative;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/mapbox/mapbox.component.css
// module id = ../../../../../src/app/mapbox/mapbox.component.css
// module chunks = main